// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSPaymentType;
(function (TCSPaymentType) {
    TCSPaymentType[TCSPaymentType["None"] = 0] = "None";
    TCSPaymentType[TCSPaymentType["CheckToSite"] = 1] = "CheckToSite";
    TCSPaymentType[TCSPaymentType["CheckToPatient"] = 2] = "CheckToPatient";
    TCSPaymentType[TCSPaymentType["DebitCard"] = 3] = "DebitCard";
    TCSPaymentType[TCSPaymentType["CheckPayableToSite"] = 4] = "CheckPayableToSite";
    TCSPaymentType[TCSPaymentType["ElectricFundsTransfer"] = 5] = "ElectricFundsTransfer";
})(TCSPaymentType || (TCSPaymentType = {}));
//# sourceMappingURL=tCSPaymentType.js.map